import axios from "axios";
import axiosRetry from "axios-retry";
import Vue from "vue";

const http = axios.create({
  timeout: 3000,
  headers: { "Content-Type": "application/x-www-form-urlencoded" },
});

http.interceptors.request.use(
  (config) => {
    config.baseURL = window.vue.$store.state.apiURL;
    config.headers.common["Session-Token"] =
      window.vue.$cookies.get("adminToken");
    config.headers.common["Api-Key"] = process.env.VUE_APP_API_TOKEN;
    return config;
  },
  (error) => {
    return Promise.reject(error);
  },
);

http.interceptors.response.use(
  async (response) => {
    if (response.request?.responseType === "blob") {
      return response;
    }
    return response.data;
  },
  (error) => {
    if (error.response.status === 401) {
      const alert = {
        show: true,
        type: "error",
        message: "Hibás hitelesítő adatok!"
      };
      if (window.vue.$route.name.toLowerCase() == "usermatrix") {
        // alert.message = "Nincs ilyen aktív hallgató!";
        alert.message = "Hiba történt";
        window.vue.$router.push("/home").catch(() => {});
        window.vue.$store.dispatch("showAlert", alert);
        return;
      }
      window.vue.$store.dispatch("showAlert", alert);
      window.vue.$router.push("/adminlogin").catch(() => {});
    }

    if (error.response.status === 403) {
      const alert = {
        show: true,
        type: "error",
        message:
          window.vue.$route.params.lang == "hu"
            ? "Nincs jogosultsága a művelethez!"
            : "No permission for this action!",
      };
      window.vue.$store.dispatch("showAlert", alert);
      window.vue.$router.push("/home").catch(() => {});
    }

    if (error.response.status === 404) {
      const alert = {
        show: true,
        type: "error",
        message:
          window.vue.$route.params.lang == "hu"
            ? "Nem található az elem!"
            : "Not found!",
      };
      window.vue.$store.dispatch("showAlert", alert);
      // window.vue.$router.push("/home").catch(() => {});
    }

    return Promise.reject(error.response);
  },
);

Vue.prototype.$http = http;
Vue.prototype.$axios = axios;

export default http;
